import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "form-list-wrapper" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card-head pb-3" }, [
  /*#__PURE__*/_createVNode("h1", { class: "card-title" }, "Manage Channel Members")
], -1)
const _hoisted_4 = { class: "form-wrap" }
const _hoisted_5 = {
  class: "row",
  id: "filterManageGuestUser"
}
const _hoisted_6 = { class: "col-lg-3" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { for: "" }, "Projects", -1)
const _hoisted_9 = { class: "col-lg-3" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "" }, "Channels", -1)
const _hoisted_12 = { class: "col-lg-3" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "" }, "Email/Name", -1)
const _hoisted_15 = { class: "col-lg-3 d-flex align-items-end" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", null, "Clear", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "row align-items-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
    /*#__PURE__*/_createVNode("h1", { class: "title mb-0" }, "channel users")
  ])
], -1)
const _hoisted_19 = {
  class: "table-responsive my-3",
  id: "filteredGuestUsers"
}
const _hoisted_20 = { class: "table table-shadowed mb-0 table-bordered" }
const _hoisted_21 = /*#__PURE__*/_createVNode("thead", { class: "table-primary text-nowrap" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Email"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Project Name"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Channel Name"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Invited Date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Valid Till"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
  ])
], -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  colspan: 6,
  class: "text-center py-4"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "table-button" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_31 = { key: 2 }
const _hoisted_32 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { colspan: 6 }, [
    /*#__PURE__*/_createVNode("p", { class: "text-danger text-center" }, [
      /*#__PURE__*/_createVNode("strong", null, "No Guest User Found !!!")
    ])
  ])
], -1)
const _hoisted_33 = { class: "my-3" }
const _hoisted_34 = { "aria-label": "Page navigation example" }
const _hoisted_35 = { class: "send-to modal-wrap lg-size" }
const _hoisted_36 = {
  class: "modal fade",
  id: "guestUserUpdate",
  tabindex: -1,
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_37 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = { class: "modal-header" }
const _hoisted_40 = { class: "d-block" }
const _hoisted_41 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_43 = { class: "modal-body" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = { class: "checkbox-neverexpire me-3" }
const _hoisted_47 = { class: "flex items-center gap-2" }
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "text-gray-700" }, "Never Expire", -1)
const _hoisted_49 = { class: "col-md-4" }
const _hoisted_50 = { class: "mb-4" }
const _hoisted_51 = /*#__PURE__*/_createVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Initial Date", -1)
const _hoisted_52 = { class: "flex items-center" }
const _hoisted_53 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar-alt" }, null, -1)
const _hoisted_54 = { class: "col-md-4" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Last Date", -1)
const _hoisted_56 = { class: "flex items-center" }
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar-alt" }, null, -1)
const _hoisted_58 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Validity Date", -1)
const _hoisted_60 = { class: "flex items-center" }
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar-alt" }, null, -1)
const _hoisted_62 = { class: "modal-footer justify-content-between" }
const _hoisted_63 = { class: "modal-wrap form-edit xl-size" }
const _hoisted_64 = {
  class: "modal fade",
  id: "editSelectedElementOfCreateNewForm",
  tabindex: -1,
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_65 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_66 = { class: "modal-content" }
const _hoisted_67 = { class: "modal-header" }
const _hoisted_68 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_69 = {
  key: 1,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_71 = { class: "modal-body" }
const _hoisted_72 = { class: "form-wrap pt-0" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "form-group" }
const _hoisted_75 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Name of the Form", -1)
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Short Description", -1)
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_81 = { key: 2 }
const _hoisted_82 = { class: "form-group" }
const _hoisted_83 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_84 = { key: 3 }
const _hoisted_85 = { class: "form-wrap pt-0" }
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_88 = {
  key: 0,
  class: "form-group"
}
const _hoisted_89 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_90 = { class: "col-lg-1" }
const _hoisted_91 = { class: "form-check" }
const _hoisted_92 = { class: "col-lg-5" }
const _hoisted_93 = { class: "col-lg-5" }
const _hoisted_94 = { class: "col-lg-1 pl-0" }
const _hoisted_95 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_96 = { class: "text-right" }
const _hoisted_97 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_99 = { key: 4 }
const _hoisted_100 = { class: "form-wrap pt-0" }
const _hoisted_101 = { class: "form-group" }
const _hoisted_102 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_103 = {
  key: 0,
  class: "form-group"
}
const _hoisted_104 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_105 = { class: "col-lg-1" }
const _hoisted_106 = { class: "form-check" }
const _hoisted_107 = { class: "col-lg-5" }
const _hoisted_108 = { class: "col-lg-5" }
const _hoisted_109 = { class: "col-lg-1 pl-0" }
const _hoisted_110 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_111 = { class: "text-right" }
const _hoisted_112 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_114 = { key: 5 }
const _hoisted_115 = { class: "form-wrap pt-0" }
const _hoisted_116 = { class: "form-group" }
const _hoisted_117 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_118 = {
  key: 0,
  class: "form-group"
}
const _hoisted_119 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_120 = { class: "col-lg-1" }
const _hoisted_121 = { class: "form-check" }
const _hoisted_122 = { class: "col-lg-5" }
const _hoisted_123 = { class: "col-lg-5" }
const _hoisted_124 = { class: "col-lg-1 pl-0" }
const _hoisted_125 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_126 = { class: "text-right" }
const _hoisted_127 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_128 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_129 = { class: "modal-footer" }
const _hoisted_130 = { class: "modal-wrap xl-size view-form" }
const _hoisted_131 = {
  class: "modal fade",
  id: "formview",
  tabindex: -1,
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_132 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_133 = { class: "modal-content" }
const _hoisted_134 = { class: "modal-header" }
const _hoisted_135 = { class: "d-block" }
const _hoisted_136 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_137 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_138 = { class: "modal-body bg-light" }
const _hoisted_139 = { class: "row equal-height-div" }
const _hoisted_140 = { class: "col-lg-8 equal-height-lg-div" }
const _hoisted_141 = /*#__PURE__*/_createVNode("ul", {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createVNode("a", {
      class: "nav-link active",
      id: "home-tab",
      "data-toggle": "tab",
      href: "#home",
      role: "tab",
      "aria-controls": "home",
      "aria-selected": "true"
    }, "Form")
  ]),
  /*#__PURE__*/_createVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createVNode("a", {
      class: "nav-link",
      id: "profile-tab",
      "data-toggle": "tab",
      href: "#profile",
      role: "tab",
      "aria-controls": "profile",
      "aria-selected": "false"
    }, "Response")
  ])
], -1)
const _hoisted_142 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_143 = {
  class: "tab-pane fade show active",
  id: "home",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_144 = { disabled: "" }
const _hoisted_145 = { class: "form-wrap pt-0" }
const _hoisted_146 = {
  class: "tab-pane fade",
  id: "profile",
  role: "tabpanel",
  "aria-labelledby": "profile-tab"
}
const _hoisted_147 = {
  key: 0,
  class: "form-wrap"
}
const _hoisted_148 = { disabled: "" }
const _hoisted_149 = {
  key: 1,
  class: "\n                          empty-holder\n                          dashed-box\n                          bg-white\n                          mb-3\n                          align-items-center\n                          m-3\n                        "
}
const _hoisted_150 = { class: "p-5 text-center w-100" }
const _hoisted_151 = { class: "empty-channel w-100" }
const _hoisted_152 = /*#__PURE__*/_createVNode("div", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-exclamation-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8zm0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
    })
  ])
], -1)
const _hoisted_153 = { class: "text-center" }
const _hoisted_154 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_155 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_156 = { key: 2 }
const _hoisted_157 = /*#__PURE__*/_createTextVNode(" You have not filled the form ")
const _hoisted_158 = /*#__PURE__*/_createTextVNode(" to fill it. ")
const _hoisted_159 = { class: "col-lg-4 equal-height-lg-div" }
const _hoisted_160 = { class: "form-wrap pt-0 mb-3" }
const _hoisted_161 = { class: "search-wrap" }
const _hoisted_162 = /*#__PURE__*/_createVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_163 = {
  key: 0,
  class: "vertical-nav-wrap"
}
const _hoisted_164 = { class: "member-list form-response" }
const _hoisted_165 = {
  key: 1,
  src: "https://dummyimage.com/35x35/c9c9c9/363636",
  alt: ""
}
const _hoisted_166 = { class: "modal-footer justify-content-between" }
const _hoisted_167 = { class: "form-sender" }
const _hoisted_168 = { class: "mb-0" }
const _hoisted_169 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user mr-1" }, null, -1)
const _hoisted_170 = /*#__PURE__*/_createTextVNode(" Sent by : ")
const _hoisted_171 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_172 = /*#__PURE__*/_createVNode("span", null, "12-12-2020", -1)
const _hoisted_173 = { class: "modal-wrap xl-size" }
const _hoisted_174 = {
  class: "modal fade",
  id: "responseModal",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_175 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_176 = { class: "modal-content" }
const _hoisted_177 = { class: "modal-header" }
const _hoisted_178 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_179 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_180 = { class: "modal-body" }
const _hoisted_181 = { class: "form-group" }
const _hoisted_182 = {
  key: 0,
  class: "form-group"
}
const _hoisted_183 = { for: "" }
const _hoisted_184 = {
  key: 1,
  class: "form-group"
}
const _hoisted_185 = { for: "" }
const _hoisted_186 = {
  key: 2,
  class: "form-group"
}
const _hoisted_187 = { for: "" }
const _hoisted_188 = {
  key: 3,
  class: "form-group"
}
const _hoisted_189 = { class: "d-inline-block ml-2" }
const _hoisted_190 = {
  key: 4,
  class: "form-group"
}
const _hoisted_191 = { class: "modal-footer" }
const _hoisted_192 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)
const _hoisted_193 = { class: "modal-wrap default-modal" }
const _hoisted_194 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "sendoption",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_195 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_196 = { class: "modal-content" }
const _hoisted_197 = { class: "modal-header" }
const _hoisted_198 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-chevron-left fa-w-10",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-left",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
  })
], -1)
const _hoisted_199 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "send option")
], -1)
const _hoisted_200 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_201 = { class: "modal-body" }
const _hoisted_202 = { class: "form-wrap pt-0" }
const _hoisted_203 = { class: "form-group" }
const _hoisted_204 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Select project", -1)
const _hoisted_205 = { class: "form-group" }
const _hoisted_206 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Select channel", -1)
const _hoisted_207 = { class: "form-group" }
const _hoisted_208 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Choose member", -1)
const _hoisted_209 = { class: "mb-0" }
const _hoisted_210 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_211 = { class: "form-group" }
const _hoisted_212 = /*#__PURE__*/_createVNode("label", { for: "" }, "Additional message", -1)
const _hoisted_213 = { class: "modal-footer d-block" }
const _hoisted_214 = { class: "row align-items-end no-gutters" }
const _hoisted_215 = { class: "col-lg-6" }
const _hoisted_216 = { class: "share-form-block form-inline" }
const _hoisted_217 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "mb-1 mr-2"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock mb-1 mr-2" }),
  /*#__PURE__*/_createTextVNode(" Share this Form : ")
], -1)
const _hoisted_218 = {
  key: 0,
  class: "form-wrap pt-0"
}
const _hoisted_219 = { class: "tooltip-block" }
const _hoisted_220 = /*#__PURE__*/_createVNode("i", { class: "far fa-question-circle ml-2" }, null, -1)
const _hoisted_221 = { class: "tooltip-msg" }
const _hoisted_222 = { class: "mb-0" }
const _hoisted_223 = { class: "col-lg-6" }
const _hoisted_224 = { class: "col-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_Loader = _resolveComponent("Loader")
  const _component_v_pagination = _resolveComponent("v-pagination")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_TitleComponent = _resolveComponent("TitleComponent")
  const _component_TextBoxComponent = _resolveComponent("TextBoxComponent")
  const _component_RadioButtonComponent = _resolveComponent("RadioButtonComponent")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_CheckBox = _resolveComponent("CheckBox")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.state.filter.projectId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.filter.projectId = $event)),
                    options: _ctx.state.projectList,
                    "close-on-select": "true",
                    onSelect: _ctx.getChannelByProject,
                    "clear-on-select": true,
                    placeholder: _ctx.$t('search_and_select'),
                    label: "name",
                    "track-by": "name"
                  }, null, 8, ["modelValue", "options", "onSelect", "placeholder"])
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.state.filter.channelId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.filter.channelId = $event)),
                    options: _ctx.state.channelList,
                    "close-on-select": "true",
                    onSelect: _ctx.getAccountFormList,
                    "clear-on-select": true,
                    placeholder: _ctx.$t('search_and_select'),
                    label: "name",
                    "track-by": "name"
                  }, null, 8, ["modelValue", "options", "onSelect", "placeholder"])
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "Type name or email",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.searchKeyword = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.searchKeyword]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("a", {
                    title: "Change Validity",
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-0 outline green",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
                  }, [
                    _hoisted_17
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_18,
          _createVNode("div", _hoisted_19, [
            _createVNode("table", _hoisted_20, [
              _hoisted_21,
              (_ctx.state.ui.postLoading.getAccountFormList)
                ? (_openBlock(), _createBlock("tbody", _hoisted_22, [
                    _createVNode("tr", null, [
                      _createVNode("td", _hoisted_23, [
                        _createVNode(_component_Loader)
                      ])
                    ])
                  ]))
                : (_ctx.state.data.guestUserList.data && _ctx.state.data.guestUserList.data.length)
                  ? (_openBlock(), _createBlock("tbody", _hoisted_24, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.guestUserList.data, (form, formIndex) => {
                        return (_openBlock(), _createBlock("tr", { key: formIndex }, [
                          _createVNode("td", null, [
                            (form.email.length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                  _createVNode("h5", null, _toDisplayString(form.email ?? form.contact_number), 1)
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_26, [
                                  _createVNode("h5", null, _toDisplayString(form.contact_number), 1)
                                ]))
                          ]),
                          _createVNode("td", null, [
                            _createVNode("p", null, _toDisplayString(form.project.name), 1)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("p", null, _toDisplayString(form.channel.name), 1)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("p", null, _toDisplayString(form.created), 1)
                          ]),
                          _createVNode("td", null, [
                            (form.invitation_validity && form.invitation_validity.start_date && form.invitation_validity.end_date)
                              ? (_openBlock(), _createBlock("p", _hoisted_27, _toDisplayString(form.invitation_validity.start_date) + " - " + _toDisplayString(form.invitation_validity.end_date), 1))
                              : (_openBlock(), _createBlock("p", _hoisted_28, _toDisplayString(form.validity_date), 1))
                          ]),
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_29, [
                              _createVNode("a", {
                                title: "Change Validity",
                                href: "javascript:void(0)",
                                class: "btn default-btn mr-0 outline green",
                                onClick: ($event: any) => (_ctx.selectForm(form))
                              }, [
                                _hoisted_30
                              ], 8, ["onClick"])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("tfoot", _hoisted_31, [
                      _hoisted_32
                    ]))
            ])
          ]),
          _createVNode("div", _hoisted_33, [
            _createVNode("nav", _hoisted_34, [
              _createVNode(_component_v_pagination, {
                modelValue: _ctx.currentPage,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentPage = $event)),
                  _ctx.nextPage
                ],
                pages: _ctx.state.data.guestUserList.last_page,
                "range-size": 1,
                a: "",
                "active-color": "#DCEDFF"
              }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, [
            _createVNode("div", _hoisted_37, [
              _createVNode("div", _hoisted_38, [
                _createVNode("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, [
                    (
                    _ctx.state.data.selectedGuestUser.user &&
                    _ctx.state.data.selectedGuestUser.user.email
                  )
                      ? (_openBlock(), _createBlock("h5", _hoisted_41, _toDisplayString(_ctx.state.data.selectedGuestUser.user.email), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
                  }, [
                    _hoisted_42
                  ])
                ]),
                _createVNode("div", _hoisted_43, [
                  _createVNode("div", _hoisted_44, [
                    _createVNode("div", _hoisted_45, [
                      _createVNode("div", _hoisted_46, [
                        _createVNode("label", _hoisted_47, [
                          _withDirectives(_createVNode("input", {
                            type: "checkbox",
                            class: "me-1",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.neverExpire = $event)),
                            "true-value": 1,
                            "false-value": 0,
                            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onNeverExpireChanged && _ctx.onNeverExpireChanged(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.state.data.neverExpire]
                          ]),
                          _hoisted_48
                        ])
                      ])
                    ]),
                    (_ctx.state.data.selectedFullDate?.startDate && _ctx.state.data.selectedFullDate?.endDate && _ctx.state.data.neverExpire !== 1)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createVNode("div", _hoisted_49, [
                            _createVNode("div", _hoisted_50, [
                              _hoisted_51,
                              _createVNode(_component_v_date_picker, {
                                modelValue: _ctx.state.data.selectedFullDate.startDate,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.selectedFullDate.startDate = $event)),
                                disabled: _ctx.state.data.neverExpire === 1,
                                class: "inline-block"
                              }, {
                                default: _withCtx(({ inputValue, togglePopover }) => [
                                  _createVNode("div", _hoisted_52, [
                                    _createVNode("button", {
                                      onClick: ($event: any) => (togglePopover()),
                                      disabled: _ctx.state.data.neverExpire === 1,
                                      class: "p-2 bg-blue-100 border border-blue-200 hover:bg-blue-200 text-blue-600 rounded-l focus:bg-blue-500 focus:text-white focus:border-blue-500 focus:outline-none"
                                    }, [
                                      _hoisted_53
                                    ], 8, ["onClick", "disabled"]),
                                    _createVNode("input", {
                                      value: inputValue,
                                      readonly: "",
                                      disabled: _ctx.state.data.neverExpire === 1,
                                      class: "bg-white text-gray-700 py-1 px-2 border rounded-r focus:outline-none focus:border-blue-500"
                                    }, null, 8, ["value", "disabled"])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_54, [
                            _hoisted_55,
                            _createVNode(_component_v_date_picker, {
                              modelValue: _ctx.state.data.selectedFullDate.endDate,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.data.selectedFullDate.endDate = $event)),
                              disabled: _ctx.state.data.neverExpire === 1,
                              class: "inline-block"
                            }, {
                              default: _withCtx(({ inputValue, togglePopover }) => [
                                _createVNode("div", _hoisted_56, [
                                  _createVNode("button", {
                                    onClick: ($event: any) => (togglePopover()),
                                    disabled: _ctx.state.data.neverExpire === 1,
                                    class: "p-2 bg-blue-100 border border-blue-200 hover:bg-blue-200 text-blue-600 rounded-l focus:bg-blue-500 focus:text-white focus:border-blue-500 focus:outline-none"
                                  }, [
                                    _hoisted_57
                                  ], 8, ["onClick", "disabled"]),
                                  _createVNode("input", {
                                    value: inputValue,
                                    readonly: "",
                                    disabled: _ctx.state.data.neverExpire === 1,
                                    class: "bg-white text-gray-700 py-1 px-2 border rounded-r focus:outline-none focus:border-blue-500"
                                  }, null, 8, ["value", "disabled"])
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ])
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          (_ctx.state.data.neverExpire !== 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_58, [
                                _hoisted_59,
                                _createVNode(_component_v_date_picker, {
                                  modelValue: _ctx.state.data.selectedDate,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.data.selectedDate = $event)),
                                  disabled: _ctx.state.data.neverExpire === 1,
                                  class: "inline-block"
                                }, {
                                  default: _withCtx(({ inputValue, togglePopover }) => [
                                    _createVNode("div", _hoisted_60, [
                                      _createVNode("button", {
                                        onClick: ($event: any) => (togglePopover()),
                                        disabled: _ctx.state.data.neverExpire === 1,
                                        class: "p-2 bg-blue-100 border border-blue-200 hover:bg-blue-200 text-blue-600 rounded-l focus:bg-blue-500 focus:text-white focus:border-blue-500 focus:outline-none"
                                      }, [
                                        _hoisted_61
                                      ], 8, ["onClick", "disabled"]),
                                      _createVNode("input", {
                                        value: inputValue,
                                        readonly: "",
                                        disabled: _ctx.state.data.neverExpire === 1,
                                        class: "bg-white text-gray-700 py-1 px-2 border rounded-r focus:outline-none focus:border-blue-500"
                                      }, null, 8, ["value", "disabled"])
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                  ])
                ]),
                _createVNode("div", _hoisted_62, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.setNewValidity && _ctx.setNewValidity(...args)))
                  }, " Set Validity "),
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
                  }, " Close ")
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_63, [
        _createVNode("div", _hoisted_64, [
          _createVNode("div", _hoisted_65, [
            _createVNode("div", _hoisted_66, [
              _createVNode("div", _hoisted_67, [
                (
                _ctx.state.selectedElement.type === 'title' ||
                _ctx.state.selectedElement.type === 'textbox' ||
                _ctx.state.selectedElement.type === 'textArea'
              )
                  ? (_openBlock(), _createBlock("h5", _hoisted_68, " Edit " + _toDisplayString(_ctx.state.selectedElement.title), 1))
                  : (_openBlock(), _createBlock("h5", _hoisted_69, " Edit " + _toDisplayString(_ctx.state.selectedElement.element.title), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideEditCreateNewForm && _ctx.hideEditCreateNewForm(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_70
                ])
              ]),
              _createVNode("div", _hoisted_71, [
                _createVNode("div", _hoisted_72, [
                  (_ctx.state.selectedElement.type === 'title')
                    ? (_openBlock(), _createBlock("div", _hoisted_73, [
                        _createVNode("div", _hoisted_74, [
                          _hoisted_75,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: "Title Here",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.selectedElement.title = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.selectedElement.title]
                          ])
                        ]),
                        _createVNode("div", _hoisted_76, [
                          _hoisted_77,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: "Description here",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.selectedElement.description = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.selectedElement.description]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.selectedElement.type === 'textbox')
                    ? (_openBlock(), _createBlock("div", _hoisted_78, [
                        _createVNode("div", _hoisted_79, [
                          _hoisted_80,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: "Title Here",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.selectedElement.title = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.selectedElement.title]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.selectedElement.type === 'textArea')
                    ? (_openBlock(), _createBlock("div", _hoisted_81, [
                        _createVNode("div", _hoisted_82, [
                          _hoisted_83,
                          _withDirectives(_createVNode("input", {
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.selectedElement.title = $event)),
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: "Title Here"
                          }, null, 512), [
                            [_vModelText, _ctx.state.selectedElement.title]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.selectedElement.type === 'checkBox')
                    ? (_openBlock(), _createBlock("div", _hoisted_84, [
                        _createVNode("div", _hoisted_85, [
                          _createVNode("div", _hoisted_86, [
                            _hoisted_87,
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "inputPassword",
                              placeholder: "Text field label",
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.selectedElement.element.title]
                            ])
                          ]),
                          (
                      _ctx.state.selectedElement.element.select_values &&
                      _ctx.state.selectedElement.element.select_values.length
                    )
                            ? (_openBlock(), _createBlock("div", _hoisted_88, [
                                _hoisted_89,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                        .select_values, (row, rowIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "row py-2",
                                    key: rowIndex
                                  }, [
                                    _createVNode("div", _hoisted_90, [
                                      _createVNode("div", _hoisted_91, [
                                        _withDirectives(_createVNode("input", {
                                          class: "form-check-input",
                                          type: "radio",
                                          name: "exampleRadios",
                                          id: "exampleRadios1",
                                          "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                        }, null, 8, ["onUpdate:modelValue"]), [
                                          [_vModelRadio, row.selected]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_92, [
                                      _withDirectives(_createVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Option label",
                                        "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelText, row.text]
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_93, [
                                      _withDirectives(_createVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Option value",
                                        "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelText, row.value]
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_94, [
                                      _createVNode("button", {
                                        type: "button",
                                        class: "option-btn",
                                        disabled: _ctx.state.selectedElement.element.select_values
                            .length === 1
                            ,
                                        onClick: ($event: any) => (_ctx.removeCheckBoxinCustomEdit(row.text))
                                      }, [
                                        _hoisted_95
                                      ], 8, ["disabled", "onClick"])
                                    ])
                                  ]))
                                }), 128)),
                                _createVNode("div", _hoisted_96, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addCheckBoxinCustomEdit && _ctx.addCheckBoxinCustomEdit(...args))),
                                    class: "btn default-btn outline secondary mt-3"
                                  }, [
                                    _hoisted_97,
                                    _hoisted_98
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.selectedElement.type === 'single_select')
                    ? (_openBlock(), _createBlock("div", _hoisted_99, [
                        _createVNode("div", _hoisted_100, [
                          _createVNode("div", _hoisted_101, [
                            _hoisted_102,
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "inputPassword",
                              placeholder: "Text field label",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.selectedElement.element.title]
                            ])
                          ]),
                          (
                      _ctx.state.selectedElement.element.select_values &&
                      _ctx.state.selectedElement.element.select_values.length
                    )
                            ? (_openBlock(), _createBlock("div", _hoisted_103, [
                                _hoisted_104,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                        .select_values, (row, rowIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "row py-2",
                                    key: rowIndex
                                  }, [
                                    _createVNode("div", _hoisted_105, [
                                      _createVNode("div", _hoisted_106, [
                                        _withDirectives(_createVNode("input", {
                                          class: "form-check-input",
                                          type: "radio",
                                          name: "exampleRadios",
                                          id: "exampleRadios1",
                                          "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                        }, null, 8, ["onUpdate:modelValue"]), [
                                          [_vModelRadio, row.selected]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_107, [
                                      _withDirectives(_createVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Option label",
                                        "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelText, row.text]
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_108, [
                                      _withDirectives(_createVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Option value",
                                        "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelText, row.value]
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_109, [
                                      _createVNode("button", {
                                        type: "button",
                                        class: "option-btn",
                                        disabled: _ctx.state.selectedElement.element.select_values
                            .length === 1
                            ,
                                        onClick: ($event: any) => (_ctx.removeSelectOptioninCustomEdit(row.text))
                                      }, [
                                        _hoisted_110
                                      ], 8, ["disabled", "onClick"])
                                    ])
                                  ]))
                                }), 128)),
                                _createVNode("div", _hoisted_111, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addSelectOptionsinCustomEdit && _ctx.addSelectOptionsinCustomEdit(...args))),
                                    class: "btn default-btn outline secondary mt-3"
                                  }, [
                                    _hoisted_112,
                                    _hoisted_113
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.selectedElement.type === 'radioButton')
                    ? (_openBlock(), _createBlock("div", _hoisted_114, [
                        _createVNode("div", _hoisted_115, [
                          _createVNode("div", _hoisted_116, [
                            _hoisted_117,
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              id: "inputPassword",
                              placeholder: "Text field label",
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.state.selectedElement.element.title = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.selectedElement.element.title]
                            ])
                          ]),
                          (
                      _ctx.state.selectedElement.element.select_values &&
                      _ctx.state.selectedElement.element.select_values.length
                    )
                            ? (_openBlock(), _createBlock("div", _hoisted_118, [
                                _hoisted_119,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedElement.element
                        .select_values, (row, rowIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "row py-2",
                                    key: rowIndex
                                  }, [
                                    _createVNode("div", _hoisted_120, [
                                      _createVNode("div", _hoisted_121, [
                                        _withDirectives(_createVNode("input", {
                                          class: "form-check-input",
                                          type: "radio",
                                          name: "exampleRadios",
                                          id: "exampleRadios1",
                                          "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                        }, null, 8, ["onUpdate:modelValue"]), [
                                          [_vModelRadio, row.selected]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_122, [
                                      _withDirectives(_createVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Option label",
                                        "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelText, row.text]
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_123, [
                                      _withDirectives(_createVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Option value",
                                        "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelText, row.value]
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_124, [
                                      _createVNode("button", {
                                        type: "button",
                                        class: "option-btn",
                                        disabled: _ctx.state.selectedElement.element.select_values
                            .length === 1
                            ,
                                        onClick: ($event: any) => (_ctx.removeOptionsinCustomEdit(row.text))
                                      }, [
                                        _hoisted_125
                                      ], 8, ["disabled", "onClick"])
                                    ])
                                  ]))
                                }), 128)),
                                _createVNode("div", _hoisted_126, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.addOptionsinCustomEdit && _ctx.addOptionsinCustomEdit(...args))),
                                    class: "btn default-btn outline secondary mt-3"
                                  }, [
                                    _hoisted_127,
                                    _hoisted_128
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_129, [
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.hideEditCreateNewForm && _ctx.hideEditCreateNewForm(...args)))
                }, " Close "),
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.updateEditNewForm && _ctx.updateEditNewForm(...args)))
                }, " Update ")
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_130, [
        _createVNode("div", _hoisted_131, [
          _createVNode("div", _hoisted_132, [
            _createVNode("div", _hoisted_133, [
              _createVNode("div", _hoisted_134, [
                _createVNode("div", _hoisted_135, [
                  _createVNode("h5", _hoisted_136, [
                    _createTextVNode(_toDisplayString(_ctx.state.formData.title) + " ", 1),
                    _createVNode("small", null, " - " + _toDisplayString(_ctx.state.formData.description), 1)
                  ])
                ]),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.hideFormView && _ctx.hideFormView(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_137
                ])
              ]),
              _createVNode("div", _hoisted_138, [
                _createVNode("div", _hoisted_139, [
                  _createVNode("div", _hoisted_140, [
                    _hoisted_141,
                    _createVNode("div", _hoisted_142, [
                      _createVNode("div", _hoisted_143, [
                        _createVNode("form", null, [
                          _createVNode("fieldset", _hoisted_144, [
                            _createVNode("div", _hoisted_145, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.formData
                              .elements, (element, elementIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "form-group",
                                  key: elementIndex
                                }, [
                                  (element.type === 'title')
                                    ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                        key: 0,
                                        title: element.title,
                                        description: element.description,
                                        editStatus: false
                                      }, null, 8, ["title", "description"]))
                                    : _createCommentVNode("", true),
                                  (element.type === 'textbox')
                                    ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                        key: 1,
                                        data: element,
                                        editStatus: false
                                      }, null, 8, ["data"]))
                                    : _createCommentVNode("", true),
                                  (element.type === 'radioButton')
                                    ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                        key: 2,
                                        data: element,
                                        editStatus: false
                                      }, null, 8, ["data"]))
                                    : _createCommentVNode("", true),
                                  (element.type === 'single_select')
                                    ? (_openBlock(), _createBlock(_component_SelectOption, {
                                        key: 3,
                                        data: element,
                                        editStatus: false
                                      }, null, 8, ["data"]))
                                    : _createCommentVNode("", true),
                                  (element.type === 'checkBox')
                                    ? (_openBlock(), _createBlock(_component_CheckBox, {
                                        key: 4,
                                        data: element,
                                        editStatus: false
                                      }, null, 8, ["data"]))
                                    : _createCommentVNode("", true),
                                  (element.type === 'textArea')
                                    ? (_openBlock(), _createBlock(_component_TextArea, {
                                        key: 5,
                                        data: element,
                                        editStatus: false
                                      }, null, 8, ["data"]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_146, [
                        (
                        _ctx.state.item.selectedUserFormDetails.elements &&
                        _ctx.state.item.selectedUserFormDetails.elements.length
                      )
                          ? (_openBlock(), _createBlock("div", _hoisted_147, [
                              _createVNode("form", null, [
                                _createVNode("fieldset", _hoisted_148, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.item
                              .selectedUserFormDetails.elements, (element, elementIndex) => {
                                    return (_openBlock(), _createBlock("div", {
                                      class: "form-group",
                                      key: elementIndex
                                    }, [
                                      (element.type === 'title')
                                        ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                            key: 0,
                                            title: element.title,
                                            description: element.description,
                                            editStatus: false
                                          }, null, 8, ["title", "description"]))
                                        : _createCommentVNode("", true),
                                      (element.type === 'textbox')
                                        ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                            key: 1,
                                            data: element,
                                            editStatus: false
                                          }, null, 8, ["data"]))
                                        : _createCommentVNode("", true),
                                      (element.type === 'radioButton')
                                        ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                            key: 2,
                                            data: element,
                                            editStatus: false
                                          }, null, 8, ["data"]))
                                        : _createCommentVNode("", true),
                                      (element.type === 'single_select')
                                        ? (_openBlock(), _createBlock(_component_SelectOption, {
                                            key: 3,
                                            data: element,
                                            editStatus: false
                                          }, null, 8, ["data"]))
                                        : _createCommentVNode("", true),
                                      (element.type === 'checkBox')
                                        ? (_openBlock(), _createBlock(_component_CheckBox, {
                                            key: 4,
                                            data: element,
                                            editStatus: false
                                          }, null, 8, ["data"]))
                                        : _createCommentVNode("", true),
                                      (element.type === 'textArea')
                                        ? (_openBlock(), _createBlock(_component_TextArea, {
                                            key: 5,
                                            data: element,
                                            editStatus: false
                                          }, null, 8, ["data"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_149, [
                              _createVNode("div", _hoisted_150, [
                                _createVNode("div", _hoisted_151, [
                                  _hoisted_152,
                                  _createVNode("div", _hoisted_153, [
                                    (
                                _ctx.state.item.selectedUserFormDetails &&
                                !_ctx.state.item.selectedUserFormDetails.length &&
                                _ctx.state.formData.sentToUsers &&
                                !_ctx.state.formData.sentToUsers.length
                              )
                                      ? (_openBlock(), _createBlock("h5", _hoisted_154, " Please choose the user from right to see the form filled up by the user "))
                                      : _createCommentVNode("", true),
                                    (
                                _ctx.state.selectedUser.email != _ctx.state.email &&
                                _ctx.state.item.selectedUserFormDetails &&
                                !_ctx.state.item.selectedUserFormDetails.length &&
                                _ctx.state.formData.sentToUsers &&
                                _ctx.state.formData.sentToUsers.length
                              )
                                      ? (_openBlock(), _createBlock("h5", _hoisted_155, " This user has not filled the form yet ! "))
                                      : _createCommentVNode("", true),
                                    (
                                _ctx.state.selectedUser.email === _ctx.state.email &&
                                _ctx.state.item.selectedUserFormDetails &&
                                !_ctx.state.item.selectedUserFormDetails.length
                              )
                                      ? (_openBlock(), _createBlock("h5", _hoisted_156, [
                                          _hoisted_157,
                                          _createVNode("a", {
                                            onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.userFormClick && _ctx.userFormClick(...args))),
                                            class: "\n                                  btn btn-outline-primary btn-sm\n                                  mx-1\n                                  rounded-pill\n                                "
                                          }, "Click here"),
                                          _hoisted_158
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]))
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_159, [
                    _createVNode("div", _hoisted_160, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, " Sent to users (" + _toDisplayString(_ctx.sentToUsers.length) + ")", 1)
                      ]),
                      _createVNode("div", _hoisted_161, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "Search User",
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.state.item.searchUser = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.item.searchUser]
                        ]),
                        _hoisted_162
                      ])
                    ]),
                    (_ctx.sentToUsers && _ctx.sentToUsers.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_163, [
                          _createVNode("ul", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sentToUsers, (user, userIndex) => {
                              return (_openBlock(), _createBlock("li", {
                                class: _ctx.state.activeUserIndex === userIndex ? 'active' : ''
                        ,
                                key: userIndex,
                                onClick: ($event: any) => (
                          _ctx.getAccountFormResponseByEmailAndId(user, userIndex)
                          )
                              }, [
                                _createVNode("div", _hoisted_164, [
                                  _createVNode("div", null, [
                                    (user.image)
                                      ? (_openBlock(), _createBlock("img", {
                                          key: 0,
                                          src: user.image,
                                          alt: ""
                                        }, null, 8, ["src"]))
                                      : (_openBlock(), _createBlock("img", _hoisted_165))
                                  ]),
                                  _createVNode("h5", null, _toDisplayString(user.email), 1)
                                ])
                              ], 10, ["onClick"]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_166, [
                _createVNode("div", _hoisted_167, [
                  _createVNode("p", _hoisted_168, [
                    _hoisted_169,
                    _hoisted_170,
                    _createVNode("span", null, _toDisplayString(_ctx.state.name), 1),
                    _hoisted_171,
                    _hoisted_172
                  ])
                ]),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.hideFormView && _ctx.hideFormView(...args)))
                }, " Close ")
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_173, [
          _createVNode("div", _hoisted_174, [
            _createVNode("div", _hoisted_175, [
              _createVNode("div", _hoisted_176, [
                _createVNode("div", _hoisted_177, [
                  _createVNode("h5", _hoisted_178, [
                    _createTextVNode(_toDisplayString(_ctx.state.formData.title) + " ", 1),
                    _createVNode("small", null, " - " + _toDisplayString(_ctx.state.formData.description), 1)
                  ]),
                  _hoisted_179
                ]),
                _createVNode("div", _hoisted_180, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userFormData, (element, elementIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "form-wrap pt-0",
                      key: elementIndex
                    }, [
                      _createVNode("div", _hoisted_181, [
                        (element.type === 'title')
                          ? (_openBlock(), _createBlock(_component_TitleComponent, {
                              key: 0,
                              title: element.title,
                              description: element.description,
                              editStatus: false
                            }, null, 8, ["title", "description"]))
                          : _createCommentVNode("", true)
                      ]),
                      (element.type === 'textbox')
                        ? (_openBlock(), _createBlock("div", _hoisted_182, [
                            _createVNode("label", _hoisted_183, _toDisplayString(element.title), 1),
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              placeholder: element.placeholder,
                              "onUpdate:modelValue": ($event: any) => (element.answer = $event)
                            }, null, 8, ["placeholder", "onUpdate:modelValue"]), [
                              [_vModelText, element.answer]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (element.type === 'radioButton')
                        ? (_openBlock(), _createBlock("div", _hoisted_184, [
                            _createVNode("label", _hoisted_185, _toDisplayString(element.title), 1),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.select_values, (option, optionIndex) => {
                              return (_openBlock(), _createBlock("div", { key: optionIndex }, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  name: "radioName",
                                  value: option.value,
                                  "onUpdate:modelValue": ($event: any) => (option.selected = $event),
                                  onChange: ($event: any) => (_ctx.radioChange(element, option))
                                }, null, 40, ["value", "onUpdate:modelValue", "onChange"]), [
                                  [_vModelRadio, option.selected]
                                ]),
                                _createVNode("label", null, _toDisplayString(option.text), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (element.type === 'single_select')
                        ? (_openBlock(), _createBlock("div", _hoisted_186, [
                            _createVNode("label", _hoisted_187, _toDisplayString(element.title), 1),
                            _withDirectives(_createVNode("select", {
                              id: "cars",
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => (element.selectedOption = $event)
                            }, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.select_values, (option, optionIndex) => {
                                return (_openBlock(), _createBlock("option", {
                                  value: option,
                                  key: optionIndex
                                }, _toDisplayString(option.text), 9, ["value"]))
                              }), 128))
                            ], 8, ["onUpdate:modelValue"]), [
                              [_vModelSelect, element.selectedOption]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (element.type === 'checkBox')
                        ? (_openBlock(), _createBlock("div", _hoisted_188, [
                            _createVNode("label", null, _toDisplayString(element.title), 1),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(element.select_values, (option, optionIndex) => {
                              return (_openBlock(), _createBlock("div", { key: optionIndex }, [
                                _withDirectives(_createVNode("input", {
                                  type: "checkbox",
                                  id: "vehicle1",
                                  name: "vehicle1",
                                  value: option.text,
                                  "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                                }, null, 8, ["value", "onUpdate:modelValue"]), [
                                  [_vModelCheckbox, option.selected]
                                ]),
                                _createVNode("label", _hoisted_189, _toDisplayString(option.text), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (element.type === 'textArea')
                        ? (_openBlock(), _createBlock("div", _hoisted_190, [
                            _createVNode("label", null, _toDisplayString(element.title), 1),
                            _withDirectives(_createVNode("textarea", {
                              class: "form-control",
                              id: "w3review",
                              name: "w3review",
                              rows: "4",
                              cols: "50",
                              "onUpdate:modelValue": ($event: any) => (element.answer = $event)
                            }, null, 8, ["onUpdate:modelValue"]), [
                              [_vModelText, element.answer]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_191, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.selectedUserAccountFormResponse && _ctx.selectedUserAccountFormResponse(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.selectedUserAccountFormResponse
                  ? "Submitting..."
                  : "Submit Form"), 1),
                  _hoisted_192
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_193, [
        _createVNode("div", _hoisted_194, [
          _createVNode("div", _hoisted_195, [
            _createVNode("div", _hoisted_196, [
              _createVNode("div", _hoisted_197, [
                _createVNode("div", {
                  class: "modal-back-btn",
                  onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.sendOptionBack && _ctx.sendOptionBack(...args)))
                }, [
                  _hoisted_198
                ]),
                _hoisted_199,
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.hideSendOptionModal && _ctx.hideSendOptionModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_200
                ])
              ]),
              _createVNode("div", _hoisted_201, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.item.error.erorListSendForm,
                  hasError: _ctx.state.item.hasError
                }, null, 8, ["errors", "hasError"]),
                _createVNode("div", _hoisted_202, [
                  _createVNode("div", _hoisted_203, [
                    _hoisted_204,
                    _withDirectives(_createVNode("select", {
                      disabled: !_ctx.state.projectList || !_ctx.state.projectList.length,
                      class: "custom-select form-control",
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.state.item.sendOption.project = $event)),
                      onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.getChannelByProjectForSendOption && _ctx.getChannelByProjectForSendOption(...args)))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.projectList, (item, itemIndex) => {
                        return (_openBlock(), _createBlock("option", {
                          value: item,
                          key: itemIndex
                        }, _toDisplayString(item.name), 9, ["value"]))
                      }), 128))
                    ], 40, ["disabled"]), [
                      [_vModelSelect, _ctx.state.item.sendOption.project]
                    ])
                  ]),
                  _createVNode("div", _hoisted_205, [
                    _hoisted_206,
                    _withDirectives(_createVNode("select", {
                      disabled: !_ctx.state.channelListForSendOption ||
                    !_ctx.state.channelListForSendOption.length
                    ,
                      class: "custom-select form-control",
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.state.item.sendOption.channel = $event)),
                      onChange: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.getUserListByProjectAndChannel && _ctx.getUserListByProjectAndChannel(...args)))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.channelListForSendOption, (item, itemIndex) => {
                        return (_openBlock(), _createBlock("option", {
                          value: item,
                          key: itemIndex
                        }, _toDisplayString(item.name), 9, ["value"]))
                      }), 128))
                    ], 40, ["disabled"]), [
                      [_vModelSelect, _ctx.state.item.sendOption.channel]
                    ])
                  ]),
                  _createVNode("div", _hoisted_207, [
                    _hoisted_208,
                    _withDirectives(_createVNode("select", {
                      disabled: !_ctx.state.userListForSendOption ||
                    !_ctx.state.userListForSendOption.length
                    ,
                      class: "form-control mb-2",
                      id: "",
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.state.existingMember = $event)),
                      onChange: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMemberInSendOption && _ctx.changeExistingMemberInSendOption(...args)))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userListForSendOption, (item, itemIndex) => {
                        return (_openBlock(), _createBlock("option", {
                          value: item,
                          key: itemIndex
                        }, _toDisplayString(item.full_name) + " (" + _toDisplayString(item.email) + ") ", 9, ["value"]))
                      }), 128))
                    ], 40, ["disabled"]), [
                      [_vModelSelect, _ctx.state.existingMember]
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "email-tag",
                        key: userIndex
                      }, [
                        _createVNode("p", _hoisted_209, [
                          _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                          }, [
                            _hoisted_210
                          ], 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createVNode("div", _hoisted_211, [
                    _hoisted_212,
                    _withDirectives(_createVNode("textarea", {
                      class: "form-control",
                      id: "w3review",
                      name: "w3review",
                      rows: "4",
                      cols: "50",
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.state.data.additionalMessage = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.additionalMessage]
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_213, [
                _createVNode("div", _hoisted_214, [
                  _createVNode("div", _hoisted_215, [
                    _createVNode("div", _hoisted_216, [
                      _hoisted_217,
                      (
                      _ctx.state.data.privacyList && _ctx.state.data.privacyList.length
                    )
                        ? (_openBlock(), _createBlock("div", _hoisted_218, [
                            _withDirectives(_createVNode("select", {
                              class: "custom-select form-control",
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.state.data.privacy = $event))
                            }, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.privacyList, (item, itemIndex) => {
                                return (_openBlock(), _createBlock("option", {
                                  value: item,
                                  key: itemIndex
                                }, _toDisplayString(item.name), 9, ["value"]))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.state.data.privacy]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_219, [
                        _hoisted_220,
                        _createVNode("div", _hoisted_221, [
                          _createVNode("h5", null, _toDisplayString(_ctx.state.data.privacy.value), 1),
                          _createVNode("p", _hoisted_222, _toDisplayString(_ctx.formPrivacyMessage), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_223, [
                    _createVNode("div", _hoisted_224, [
                      _createVNode("button", {
                        type: "button",
                        class: "btn default-btn",
                        onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.sendDigitizedForm && _ctx.sendDigitizedForm(...args)))
                      }, _toDisplayString(_ctx.state.ui.isPostLoading.sendDigitizedForm
                      ? "Sending..."
                      : "Send"), 1),
                      _createVNode("button", {
                        type: "button",
                        class: "btn secondary-btn",
                        "data-dismiss": "modal",
                        onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.hideSendOptionModal && _ctx.hideSendOptionModal(...args)))
                      }, " Cancel ")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}